export default "__VITE_ASSET__C2Cd$Zdr__"